import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { AppConfig, SystemHeader } from '../service/DTOs';
import * as TF from '../service/tradeflow';
import * as DTO from '../service/DTOs';
import * as API from '../service/apisvc';
import * as RB from 'react-bootstrap';
import * as Actions from '../service/Actions';
import * as Dispatch from '../service/Dispatcher';
import { MatrixFormFilter, initialstate_matrixfilter } from './view/MatrixFormFilter'
import { SecurityRecord, initialstate_secrecord } from './view/filterrecords/SecurityRecord'
import { EntityLimitsRecord, initialstate_entitylimitsrecord } from './view/filterrecords/EntityLimitsRecord'

import { SpinnerBlock } from './shared/effects/Spinners'

import 'isomorphic-fetch';

import { Typeahead, AsyncTypeahead } from 'react-bootstrap-typeahead';
import { LimitsListItem } from './view/LimitsListItem';

const iconSpinner = <SpinnerBlock />

type MatrixContragentLimits = new () => MatrixFormFilter<DTO.EntityWLimits>;


type LimitsSettingsProps = LimitsSettingsState & { xsrfToken?: string }
    ;

interface LimitsSettingsState {
    //connection: DTO.HubConnection;
    syshdr: DTO.SystemHeader;
    instruments: DTO.InstrumentHead[],
    currencies: DTO.Currency[];
    //durations: DTO.Duration[];

    loading?: boolean;
}

export class LimitsSettings extends React.Component<LimitsSettingsProps, LimitsSettingsState> {
    caFilter: MatrixFormFilter<DTO.EntityWLimits> | null = null;
    //panelElem: HTMLDivElement | null;

    constructor(props: LimitsSettingsProps) {
        super(props);
        //this.state = {
        //    ...{ connection: props.connection }, ...{ syshdr: props.syshdr }, ...{ messages: [] }
        //};

        this.state = {
            ...{ syshdr: props.syshdr }, ...{ currencies: [], instruments: [], loading: true } // instruments: [], 
        };

        fetch(API.apiUrl(API.API_CONFIG_URL), {
            method: 'GET',
            credentials: 'include',
            headers: new Headers({
                ...{ 'X-XSRF-TOKEN': props.xsrfToken || '' },
                ...API.authHeader()
            })
        })
            .then(response => {
                if (response.ok) {
                    return response.json() as Promise<DTO.AppConfig>
                } else {
                    var cmd_hdr = response.headers.get(API._API_CMD_HEADER);

                    if (cmd_hdr) {
                        TF.PublishSysCommand(cmd_hdr);
                    }
                    var error = new Error(response.statusText);
                    throw error;
                }
            }
            )
            .then(data => {
                this.setState({ currencies: data.currencies, instruments: data.instruments, loading: false }); // instruments: data.instruments, 
            })
            .catch(reason => {
                console.log(reason);
            })
            ;
        //this.onSubmit = this.onSubmit.bind(this);
    }



    handleSelectContextCa(locatorId?: string, record?: DTO.EntityWLimits) {
        if (this.caFilter)
            this.caFilter.handleSelectContext(locatorId, record);
    }

    handleRemoveCaLimit(locatorId?: string, record?: DTO.EntityWLimits) {
        if (this.caFilter)
            this.caFilter.handleRemove(locatorId, record);
    }

    handleCreateCaLimit(locatorId?: string, record?: DTO.EntityWLimits) {
        if (this.caFilter && record)
            this.caFilter.handleProcess(record, () => this.processAppendCALimit(record));
    }

    //handleRemoveLimitContext(record?: DTO.EntityWLimits, marginpick?: DTO.NotesContragentMarginPick) {
    //    if (this.caFilter && record && marginpick)
    //        this.caFilter.handleProcess(record, ()=> this.processRemoveLimitContext(record, marginpick) );
    //}


    //handleAppendLimitContext(record?: DTO.EntityWLimits, cur?: DTO.Currency, dur?: DTO.Duration) {
    //    if (this.caFilter && record && cur && dur) {
    //        let newmp: DTO.NewNotesContragentMarginPick = {
    //            idcurrency: cur.id,
    //            idduration: dur.id,
    //            givemargin: 0
    //        }

    //        this.caFilter.handleProcess(record, () => this.processAppendLimitContext(record, newmp));
    //    }
    //}

    handlechangeLimit(record?: DTO.EntityWLimits, margin?: DTO.NotesContragentMargin) {
        if (this.caFilter && record && margin) {
            this.caFilter.handleProcess(record, () => this.processApplyLimitChange(margin));
        }
    }
    

    dispatchCaFilterSettings = (action: Actions.ContragentLimitsAction) => {
        if (action.type == 'RESET_CONTRAGENTLIMITS_MODIFICATION_FORM') {
            if (this.caFilter) {
                this.caFilter.typeahead.getInstance().clear();
            }
        }

        if (this.caFilter) {
            return Dispatch.ContragentLimitsDispatcher(this.caFilter, action);
        }

        return {};
    }

    processAppendCALimit(entity: DTO.EntityWLimits) {
        let _marginpl= {
            idcontragent: entity.id,
            alertnote: '',
            allowed: true,
            margins: []
        }

        let manipulation: DTO.ManipulationAction<DTO.NotesContragentMargin> = {
            locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
            type: DTO.MANIPULATION_PERM_FILTER_INCLUDE,
            locatorId: '0',
            payload: _marginpl
        }

        return Actions.caLimitActions.modifypick(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatchCaFilterSettings);
    }

    processRemoveCA(entity: DTO.EntityWLimits) {
        let _marginpl = Object.assign({}, entity.marginTo);
        //_marginpl.margins = [marginpick];

        let manipulation: DTO.ManipulationAction<DTO.NotesContragentMargin> = {
            locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
            type: DTO.MANIPULATION_PERM_FILTER_EXCLUDE,
            locatorId: '' + entity.id,
            payload: _marginpl
        }

        return Actions.caLimitActions.modifypick(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatchCaFilterSettings);
    }

    processApplyLimitChange = (margin: DTO.NotesContragentMargin) => {
        let manipulation: DTO.ManipulationAction<DTO.NotesContragentMargin> = {
            locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
            type: DTO.MANIPULATION_PERM_ELEMENT_CHANGE,
            locatorId: '' + margin.id,
            payload: margin
        }

        //return Actions.caLimitActions.modifypick(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatchCaFilterSettings);
        return Actions.caLimitActions.modifypick(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, () => { return {}; });
    }

    //processAppendLimitContext = (entity: DTO.EntityWLimits, newmarginpick: DTO.NewNotesContragentMarginPick) => {
    //    let pick: DTO.NotesContragentMarginPick = {
    //        idcurrency: newmarginpick.idcurrency,
    //        idduration: newmarginpick.idduration,
    //        givemargin: newmarginpick.givemargin,
    //        free2givedeal: 0,
    //        free2giveorder: 0,
    //        givendeal: 0,
    //        givenorder: 0,
    //        id: 0
    //    };

    //    let marginpl: DTO.NotesContragentMargin;
    //    if (entity.marginTo) {
    //        marginpl = Object.assign({}, entity.marginTo);
    //        //marginpl.margins.push(pick);
    //        marginpl.margins = [pick];
    //    }
    //    else {
    //        marginpl = {
    //            idcontragent: entity.id,
    //            alertnote: '',
    //            allowed: true,
    //            margins: [pick]
    //        }
    //    }

    //    let manipulation: DTO.ManipulationAction<DTO.NotesContragentMargin> = {
    //        locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
    //        type: DTO.MANIPULATION_PERM_ELEMENT_APPEND,
    //        locatorId: '0',
    //        payload: marginpl
    //    }

    //    return Actions.caLimitActions.modifypick(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatchCaFilterSettings);
    //}


    //processRemoveLimitContext = (entity: DTO.EntityWLimits, marginpick: DTO.NotesContragentMarginPick) => {
    //    let _marginpl: DTO.NotesContragentMargin;
    //    if (entity.marginTo) {
    //        _marginpl = Object.assign({}, entity.marginTo);
    //        _marginpl.margins = [marginpick];
    //    }
    //    else {
    //        _marginpl = {
    //            idcontragent: entity.id,
    //            alertnote: '',
    //            allowed: true,
    //            margins: [marginpick]
    //        }
    //    }

    //    let manipulation: DTO.ManipulationAction<DTO.NotesContragentMargin> = {
    //        locatorType: DTO.MANIPULATION_LOCATOR_TYPE_ID,
    //        type: DTO.MANIPULATION_PERM_ELEMENT_REMOVE,
    //        locatorId: '' + marginpick.id,
    //        payload: _marginpl
    //    }

    //    return Actions.caLimitActions.modifypick(manipulation, () => { return { xsrfToken: this.props.xsrfToken }; }, this.dispatchCaFilterSettings);
    //}

    reloadFilterStateRecord(record: DTO.EntityWLimits): Promise<DTO.EntityWLimits> {
        let _that = this;
        return new Promise(function (resolve, reject) {
            fetch(API.apiUrl(API.API_CALIMITSLIST_URL), {
                method: 'GET',
                credentials: 'include',
                headers: new Headers({
                    ...{ 'X-XSRF-TOKEN': _that.props.xsrfToken || '' },
                    ...API.authHeader()
                })
            })
                .then(response => {
                    if (response.ok) {
                        return response.json() as Promise<DTO.EntityWLimits[]>
                    } else {
                        var error = new Error(response.statusText);
                        throw error;
                    }
                }
                )
                .then(data => {
                    let newrec = data.find(obj => obj.id == record.id);
                    return resolve(newrec);
                })
                .catch(reason => {
                    console.log(reason);
                    reject(reason);
                });
        });
    }

    loadFilterStateCA(): Promise<DTO.EntityWLimits[]> {
        let _that = this;
        return new Promise(function (resolve, reject) {
            fetch(API.apiUrl(API.API_CALIMITSLIST_URL), {
                method: 'GET',
                credentials: 'include',
                headers: new Headers({
                    ...{ 'X-XSRF-TOKEN': _that.props.xsrfToken || '' },
                    ...API.authHeader()
                })
            })
                .then(response => {
                    if (response.ok) {
                        return response.json() as Promise<DTO.EntityWLimits[]>
                    } else {
                        var error = new Error(response.statusText);
                        throw error;
                    }
                }
                )
                .then(data => {
                    return resolve(data);
                })
                .catch(reason => {
                    console.log(reason);
                    reject(reason);
                });
        });
    }

    renderElementCa(data: DTO.EntityWLimits, idx: number) {

        return <LimitsListItem key={'elemlistitem_' + idx} entity={data} />
    };


    getOptionsCa = (query: string) => {
        return fetch(API.apiUrl(API.API_ENTITYLOOKUP_URL) + "/" + `${query}` + ".json", {
            method: 'GET',
            credentials: 'include',
            headers: new Headers({
                ...
                {
                    'Content-Type': 'application/json',
                    'X-XSRF-TOKEN': this.props.xsrfToken || ''
                },
                ...API.authHeader()
            })
        })
            .then((response) => {
                return response.json();
            }).then((json) => {
                return { options: json };
            });
    }

    //className='table table-header-fixed table-condensed'
    //rowSpan = { 2}
    renderFilterTableCa(records: DTO.EntityWLimits[], processing: boolean, rowRenderer: (data: DTO.EntityWLimits, selected_locatorId?: string) => JSX.Element, selected_locatorId?: string) {
        //console.log('renderFilterTableCa records');
        //console.log(records);

        //let durList = this.state.durations;
        //let dlen = durList.length;

        //let insList = this.state.instruments;
        let insList = [...this.state.instruments].sort((a, b) => { return a && b ? (a.pos > b.pos ? 1 : (b.pos > a.pos ? -1 : 0)) : 0; });
        let dlen = insList.length;


        let directWidthPerc = 40;
        let durWidthPerc = dlen > 0 ? directWidthPerc / dlen : directWidthPerc;

        return <table className='table table-header-fixed table-condensed'>
            <thead>
                <tr style={{ width: '100%' }}>
                    <th style={{ textAlign: 'left', width: '20px' }} ></th>
                    <th style={{ textAlign: 'center', width: '10%' }} >Контрагент</th>
                    {/*<th style={{ textAlign: 'center', width: '50px' }} >Валюта</th>*/}
                    <th style={{ textAlign: 'center', width: '80%' }} colSpan={2}>Лимиты</th>
                    <th style={{ textAlign: 'center', width: 'calc(10% - 20px)' }} >Предупреждение</th>
                </tr>

                <tr style={{ width: '100%' }}>
                    <th style={{ width: '20px' }} ></th>
                    <th style={{ width: '10%' }} ></th>
                    {/*<th style={{ width: '50px' }} ></th>*/}
                    <th className="otc-margin-out" style={{ textAlign: 'center', width: directWidthPerc + '%' }} colSpan={dlen}>Продажа</th>
                    <th className="otc-margin-in" style={{ textAlign: 'center', width: directWidthPerc + '%' }} colSpan={dlen}>Покупка</th>
                    <th style={{ width: 'calc(10% - 20px)' }} ></th>
                </tr>

                {dlen > 0 ?
                    <tr style={{ width: '100%' }}>
                        <th style={{ width: '20px' }} ></th>
                        <th style={{ width: '10%' }} ></th>
                        {/*<th style={{ width: '50px' }} ></th>*/}
                        {insList.map((x, i) => {
                            return <th key={x.id} className="otc-margin-out" style={{ textAlign: 'center', width: durWidthPerc + '%' }}>{x.name}</th>
                            })
                        }
                        {insList.map((x, i) => {
                            return <th key={x.id} className="otc-margin-in" style={{ textAlign: 'center', width: durWidthPerc + '%' }}>{x.name}</th>
                            })
                        }
                        <th style={{ width: 'calc(10% - 20px)' }} ></th>
                    </tr>
                    : undefined
                }

            </thead>
            {/*style={{ height: '145px' }} */}
            {/*style={{ height: '250px' }}*/}
            <tbody style={{ height: '250px' }}>
                {records.map(ent =>
                    rowRenderer(ent, selected_locatorId)
                )}
            </tbody>
        </table>;
    }

    //private focusField(that: LimitsSettings) {
    //    if (that.msgElem)
    //        that.msgElem.focus();
    //}

    //private scrollDown(that: LimitsSettings) {
    //    let div = that.panelElem;
    //    if (div) {
    //        div.scrollTop = div.scrollHeight;
    //    }
    //}

    componentDidMount() {
        //TF.DataProcessBinding(this, { type: 'SYS.MSG.newmessage', delegate: (msg: DTO.AgentTextMessage) => this.processIncomingTextMessage(this, msg) });
        //TF.DataProcessBinding(this, { type: 'SYS.MSG.messages', delegate: (msgs: DTO.AgentTextMessage[]) => this.processTopMessages( msgs) });
        
    }
    //<p><em>Processing...</em></p>

    public render() {
        const MatrixContragentLimitsEl = MatrixFormFilter as MatrixContragentLimits;
        let contentsFilterCA = this.state.loading
            ?            
            <div style={{ minHeight: '100px' }}>{iconSpinner}</div>
            : <MatrixContragentLimitsEl ref={(caFilter) => this.caFilter = caFilter} key={'MatrixContragentLimits'}
                titleOfElem={"Контрагент"} titlePlural={'Избранные контрагенты'} isLoading={this.state.loading} xsrfToken={this.props.xsrfToken} {...initialstate_matrixfilter}
                processAppend={this.processAppendCALimit.bind(this)} processRemove={this.processRemoveCA.bind(this)}
                loadFilterState={this.loadFilterStateCA.bind(this)}
                reloadFilterStateRecord={this.reloadFilterStateRecord.bind(this)}
                getOptions={this.getOptionsCa.bind(this)}
                renderFilterTableRow={(entity, selected_locatorId?: string) => (
                    <EntityLimitsRecord key={'ca_item_' + entity.id} record={entity} xsrfToken={this.props.xsrfToken} {...initialstate_entitylimitsrecord}
                        processing={this.caFilter ? this.caFilter.state.processing : false}
                        entitySelected={this.handleSelectContextCa.bind(this)}
                        entityRemove={this.handleRemoveCaLimit.bind(this)}
                        instruments={this.state.instruments}
                        currencies={this.state.currencies}
                        //limitCtxRemove={this.handleRemoveLimitContext.bind(this)}
                        //limitCtxAppend={this.handleAppendLimitContext.bind(this)}
                        limitApplyChange={this.handlechangeLimit.bind(this)}                        
                        limitsCreate={this.handleCreateCaLimit.bind(this)}
                        selected={selected_locatorId ? selected_locatorId == '' + entity.id : false}
                    />
                )}

                lookupFilterBy={['fullname', 'shortname', 'reutercode', 'addresslegal']}
                llokupLabelKey={'shortname'}
                renderLookupMenuItemChildren={(entity, props, idx) => (
                    <LimitsListItem key={'elemlistitem_' + idx} entity={entity} />
                )}
                renderElement={this.renderElementCa.bind(this)}
                renderFilterTable={this.renderFilterTableCa.bind(this)}
            />;

        // style={{ minHeight: '380px', margin: '0px 2px 0px 2px' }}
        return <div ref="settingsRef" className="otc-trade">
            <RB.Row>
                <RB.Col sm={12}>
                    <RB.Well bsSize="sm" className='otc-filter-panel'>
                        <div>
                            <div style={{ fontSize: '14px' }}><b>{'Установленные лимиты'}</b></div>
                        </div>
                        <div>{contentsFilterCA}</div>
                    </RB.Well>

                </RB.Col>
            </RB.Row>

        </div>;
    }

}
